import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { ExpenseTable, UpdateExpenseModal } from "../components";
import { useExpenseStore } from "../store";

export const Expense = () => {
  const [expense, setExpense] = useState(null);

  const openRecordExpenseModal = useExpenseStore(
    state => state.openRecordExpenseModal
  );

  const { hash } = useLocation();

  useEffect(() => {
    if (hash === "#record-expense") {
      openRecordExpenseModal();
    }
  }, [hash, openRecordExpenseModal]);

  return (
    <>
      <UpdateExpenseModal data={expense} />
      <ExpenseTable onEdit={record => setExpense(record)} />
    </>
  );
};
